// Form styles: shared by both mount modes (mode: 'modal' wraps this in the shell styles below,
// mode: 'inline' uses only this). Same visual language as ../style.ts (gradient, font stack).
export const stepUpFormStyles = `
:host {
  display: block;
  font-family: inherit;
}
.zid-stepup-form {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-family: inherit;
  width: 20rem;
  max-width: 100%;
}
.zid-stepup-brand {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  text-align: center;
  color: #0069b4;
}
.zid-stepup-icon-circle {
  align-self: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 9999px;
  background: rgba(37, 99, 235, 0.12);
  color: #2563eb;
}
.zid-stepup-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
}
.zid-stepup-icon-circle svg {
  display: block;
  width: 1.625rem;
  height: 1.625rem;
}
.zid-stepup-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
  text-align: center;
  color: #0f172a;
}
.zid-stepup-prompt {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.5;
  text-align: center;
  color: rgba(30, 58, 95, 0.72);
}
.zid-stepup-field {
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
}
.zid-stepup-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #1e3a5f;
}
.zid-stepup-label--visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
.zid-stepup-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.zid-stepup-input-icon {
  position: absolute;
  left: 0.85rem;
  display: inline-flex;
  color: rgba(30, 58, 95, 0.45);
  pointer-events: none;
}
.zid-stepup-input-icon svg {
  width: 1.05rem;
  height: 1.05rem;
}
.zid-stepup-input {
  box-sizing: border-box;
  width: 100%;
  height: 2.75rem;
  padding: 0 0.85rem 0 2.5rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-family: inherit;
  font-size: 1.1rem;
  letter-spacing: 0.2em;
  text-align: center;
  font-variant-numeric: tabular-nums;
  color: #1e3a5f;
}
.zid-stepup-input::placeholder {
  letter-spacing: normal;
  font-size: 0.85rem;
  color: rgba(30, 58, 95, 0.45);
}
.zid-stepup-input:focus {
  outline: 2px solid #2563eb;
  outline-offset: 1px;
}
.zid-stepup-error {
  margin: 0;
  font-size: 0.78rem;
  color: #dc2626;
}
.zid-stepup-nocode {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  font-size: 0.78rem;
  color: rgba(30, 58, 95, 0.72);
}
.zid-stepup-resend {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  border: 0;
  background: none;
  padding: 0;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 600;
  color: #2563eb;
  cursor: pointer;
}
.zid-stepup-resend-icon {
  display: inline-flex;
}
.zid-stepup-resend-icon svg {
  width: 0.9rem;
  height: 0.9rem;
}
.zid-stepup-resend:disabled {
  color: rgba(30, 58, 95, 0.4);
  cursor: default;
}
.zid-stepup-actions {
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
}
.zid-stepup-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 2.75rem;
  border: 0;
  border-radius: 9999px;
  background: linear-gradient(to right, #2563eb, #312e81);
  color: #ffffff;
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s cubic-bezier(0, 0, 0.2, 1);
}
.zid-stepup-submit:hover:not(:disabled) {
  background: linear-gradient(to right, #1d4ed8, #1e1b4b);
}
.zid-stepup-submit:disabled {
  opacity: 0.7;
  cursor: default;
}
.zid-stepup-cancel {
  border: 0;
  background: none;
  padding: 0;
  align-self: center;
  font-family: inherit;
  font-size: 0.78rem;
  font-weight: 500;
  color: rgba(30, 58, 95, 0.72);
  cursor: pointer;
}
.zid-stepup-cancel:hover:not(:disabled) {
  text-decoration: underline;
}
.zid-stepup-cancel:disabled {
  opacity: 0.55;
  cursor: default;
}
.zid-stepup-terminal {
  margin: 0;
  font-size: 0.85rem;
  text-align: center;
  color: #1e3a5f;
}
.zid-stepup-divider {
  width: 100%;
  height: 1px;
  margin: 0;
  border: 0;
  background: #e5e7eb;
}
.zid-stepup-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}
.zid-stepup-footer-logo {
  display: inline-flex;
}
.zid-stepup-footer-logo svg {
  width: 6.5rem;
  height: auto;
}
.zid-stepup-footer-copy {
  margin: 0;
  font-size: 0.7rem;
  color: rgba(30, 58, 95, 0.5);
}
`

// Modal shell: backdrop + dialog chrome, used only by mode: 'modal' (concatenated with the
// form styles above into a single <style> tag).
export const stepUpModalStyles = `
.zid-stepup-backdrop {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: rgba(15, 23, 42, 0.55);
  z-index: 2147483000;
}
.zid-stepup-dialog {
  position: relative;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 16px;
  padding: 1.75rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.35);
}
.zid-stepup-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  width: 1.75rem;
  height: 1.75rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 9999px;
  background: none;
  font-size: 1.1rem;
  line-height: 1;
  color: rgba(30, 58, 95, 0.6);
  cursor: pointer;
}
.zid-stepup-close:hover {
  background: rgba(30, 58, 95, 0.08);
}
`
